import React from "react";
import NewAreas from "./NewAreas";
import AreasBoard from "./AreasBoard";
import { CustomCard, Title } from "../../Utils/UI/Text";

const Areas = () => {
  return (
    <>
      <Title children={"Areas"} childrenTwo={<NewAreas />} />

      <CustomCard>
        <AreasBoard />
      </CustomCard>
    </>
  );
};

export default Areas;
